import { render, staticRenderFns } from "./SendEmailLink.vue?vue&type=template&id=e8643306&scoped=true"
import script from "./SendEmailLink.vue?vue&type=script&lang=js"
export * from "./SendEmailLink.vue?vue&type=script&lang=js"
import style0 from "./SendEmailLink.vue?vue&type=style&index=0&id=e8643306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8643306",
  null
  
)

export default component.exports